<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Certification Details</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="certificationForm" autocomplete="off">
        <fieldset>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label>ID Type</label>
                    <select class="mvd_form-control" formControlName="customerCertificationTypeId">
                        <ng-container *ngIf="certificationId == 0">
                            <option *ngFor="let certificationType of certificationTypeContainer.customerCertificationTypes" [value]="certificationType.id">{{certificationType.displayValue}}</option>
                        </ng-container>
                        <option *ngIf="certificationId != 0" [value]="certificationTypeId">{{certificationTypeDisplayValue}}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="certificationForm.controls['customerCertificationTypeId'].touched && certificationForm.controls['customerCertificationTypeId'].hasError('required')">Certification type is required</div>
                    </div>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label class="required" title="* Required">ID Number</label>
                    <input class="mvd_form-control" formControlName="certificateNumber" [readonly]="certificationId != 0" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="certificationForm.controls['certificateNumber'].touched && certificationForm.controls['certificateNumber'].hasError('required')">Certification number is required</div>
                    </div>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Description</label>
                    <input class="mvd_form-control" formControlName="description" />
                </div>
                <div class="col-sm-1 mvd_form-group" *ngIf="certificationId != 0">
                    <label>&nbsp;</label>
                    <a class="icon--delete" title="Delete Certification" href="javascript:void(0)" (click)="deleteCertification()"></a>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Effective Date</label>
                    <p-calendar [showIcon]="true" formControlName="effectiveDate" [maxDate]=maxDate></p-calendar>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="certificationForm.get('effectiveDate').hasError('required')">Effective date is required</div>
                        <div class="mvd_alert__rule" *ngIf="certificationForm.hasError('startAfterEndDate')">Effective date cannot be after End date</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Expiration Date</label>
                    <p-calendar [showIcon]="true" formControlName="expirationDate"></p-calendar>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button type="button" class="btn--default" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(certificationForm.valid && certificationForm.dirty)" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="saveCertification()"></mvm-spinner-btn>
    </div>
</div>